var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalisedGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 269,
    height: 180.533,
    viewBox: "0 0 269 180.533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-198.2 -2242.398)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.2 2242.398)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.458,
    cy: 8.458,
    r: 8.458,
    transform: "translate(51.672 7.279)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.551,
    cy: 6.551,
    r: 6.551,
    transform: "translate(61.237 24.194)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.551,
    cy: 6.551,
    r: 6.551,
    transform: "translate(210.191 24.196)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.777,
    cy: 9.777,
    r: 9.777,
    transform: "translate(223.293 0)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.739,582.59H69.113v-.683H209.836Z",
    transform: "translate(-69.113 -404.028)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,582.59H69.113v-.683h72.934Z",
    transform: "translate(51.113 -421.961)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,582.59H69.113v-.683h72.934Z",
    transform: "translate(83.395 -441.027)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,582.59H69.113v-.683h72.934Z",
    transform: "translate(117.713 -460.092)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.538,718.133l2.306.271a11.241,11.241,0,0,0,6.328,1.428,1.9,1.9,0,0,0,1.608-.985h0a1.88,1.88,0,0,0-1.227-2.727l-1.753-.408-4.229-4.136-2.551-4.617-3.706.425-.771,5.865h0A4.54,4.54,0,0,0,175.538,718.133Z",
    transform: "translate(-87.732 -541.963)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.329,708.941l2.26.532a11.24,11.24,0,0,0,6.124,2.139,1.9,1.9,0,0,0,1.709-.8h0a1.881,1.881,0,0,0-.908-2.85l-1.695-.605-3.73-4.591-2.008-4.878h-3.73l-1.435,5.739h0A4.539,4.539,0,0,0,291.329,708.941Z",
    transform: "translate(-167.603 -550.991)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,531.475l-4.218.649L202.7,498.541l-11.519-10.1L177.229,545.55l-5.192.973c.582-32.159-2.259-72.645,4.218-77.548l28.229,3.245,12.33,23.563Z",
    transform: "translate(-87.99 -378.527)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.734,
    cy: 9.734,
    r: 9.734,
    transform: "translate(95.404 21.012)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.63,149.935l11.681,1.947,2.92-10.383-8.436-2.6Z",
    transform: "translate(66.88 -104.263)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.62,364.28l31.149,2.92c-2.5-8.683-4.785-17.336-2.92-25.957,2.368-7.7.082-12.274-6.165-15.9l-4.218-9.409-11.356-1.3h0a24.512,24.512,0,0,0-3.479,16.21C185.248,343.119,184.811,354.507,180.62,364.28Z",
    transform: "translate(-93.977 -272.535)",
    fill: "#c00096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.6,242.793c3.324-.23,7.168-.293,7.649.583,3.443-.161,6.441,1.04,7.824,3.834a1.842,1.842,0,0,1-1.15,2.579,19.112,19.112,0,0,1-6.35.927c-4.034,4.742-2.336,13.391,1.579,18.444l-3.538.725-6.714-9.349,2.118,10.291-8.17,1.336L196,259.086a19.88,19.88,0,0,1,.437-9.342,7.511,7.511,0,0,1,.342-.9A10.431,10.431,0,0,1,205.6,242.793Z",
    transform: "translate(-104.292 -223.094)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.635,411.716l-.215,7.533a4.107,4.107,0,0,0,3.7,4.2h0a4.107,4.107,0,0,0,4.374-5.158l-1.69-6.254-4.867-26.606.324-15.575-10.383-.325,1.947,17.521Z",
    transform: "translate(-118.875 -310.236)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,334.879a16.407,16.407,0,0,1,11.681,0l-.649-12.979a5.191,5.191,0,0,0-5.191-5.191h0a5.191,5.191,0,0,0-5.192,5.192Z",
    transform: "translate(-117.452 -273.957)",
    fill: "#c00096"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.153,296.989a19.3,19.3,0,0,0,1.5-2.2L146.1,293.058l11.408.086a19.23,19.23,0,0,0,.371-15.227l-15.3,7.934,14.107-10.371A19.22,19.22,0,1,0,124.951,297a19.156,19.156,0,0,0-2.191,3.505l13.674,7.1-14.589-4.9a19.235,19.235,0,0,0,3.111,18.048,19.091,19.091,0,0,0-3.446,6.858,191.462,191.462,0,0,0,9.049,21.735,19.027,19.027,0,0,0,5.963,2.18,6.665,6.665,0,0,0-.379,2.232,6.339,6.339,0,0,0,.809,3.21,6.224,6.224,0,0,0-.819,2.738h0a118.214,118.214,0,0,0,7.8,11.667,5.9,5.9,0,0,0-.633-1.556,6.588,6.588,0,0,0,0-6.42,6.588,6.588,0,0,0,0-6.419,6.339,6.339,0,0,0,.835-3.21,6.583,6.583,0,0,0-.389-2.263,19.22,19.22,0,0,0,11.408-30.742,19.214,19.214,0,0,0,0-23.765Z",
    transform: "translate(83.246 2049.587)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.153,296.989a19.3,19.3,0,0,0,1.5-2.2L146.1,293.058l11.408.086a19.23,19.23,0,0,0,.371-15.227l-15.3,7.934,14.107-10.371A19.22,19.22,0,1,0,124.951,297a19.156,19.156,0,0,0-2.191,3.505l13.674,7.1-14.589-4.9a19.235,19.235,0,0,0,3.111,18.048,19.091,19.091,0,0,0-3.446,6.858,191.462,191.462,0,0,0,9.049,21.735,19.027,19.027,0,0,0,5.963,2.18,6.665,6.665,0,0,0-.379,2.232,6.339,6.339,0,0,0,.809,3.21,6.224,6.224,0,0,0-.819,2.738h0a118.214,118.214,0,0,0,7.8,11.667,5.9,5.9,0,0,0-.633-1.556,6.588,6.588,0,0,0,0-6.42,6.588,6.588,0,0,0,0-6.419,6.339,6.339,0,0,0,.835-3.21,6.583,6.583,0,0,0-.389-2.263,19.22,19.22,0,0,0,11.408-30.742,19.214,19.214,0,0,0,0-23.765Z",
    transform: "translate(307.924 2051.558)",
    fill: "#e4efff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalisedGoal);
export default __webpack_public_path__ + "static/media/personalised_goal.3f2e347e131e88d66fb8500c79c2d832.svg";
export { ForwardRef as ReactComponent };